import { Box, Container, Typography } from "@mui/material";

import {
  FaAward,
  FaClock,
  FaMagic,
  FaShieldAlt,
  FaTshirt,
  FaUsers,
} from "react-icons/fa";

import beforeAfterBg from "../../assets/images/before_after_bg2.png";
import beforeAfterBgM from "../../assets/images/before_after_bg_m2.png";
import beforeAfterImage from "../../assets/images/before_after_main.png";
import bg_2 from "../../assets/images/bg_4.png";

const features = [
  {
    icon: <FaMagic />,
    title: "Stain Removal Experts",
    desc: "Tough on stains, gentle on fabric",
  },

  {
    icon: <FaShieldAlt />,
    title: "Premium Fabric Care",
    desc: "High quality cleaning & protection",
  },

  {
    icon: <FaTshirt />,
    title: "Wrinkle-Free Finish",
    desc: "Perfectly pressed, ready to wear",
  },

  {
    icon: <FaClock />,
    title: "Same Day Service",
    desc: "Clean clothes, on your schedule",
  },
];

const stats = [
  {
    number: "99%",
    label: "Stain Removal",
    icon: <FaAward />,
  },
  {
    number: "1000+",
    label: "Happy Customers",
    icon: <FaUsers />,
  },
  {
    number: "10+",
    label: "Years Experience",
    icon: <FaShieldAlt />,
  },
];

function BeforeAfterSection() {
  return (
    <Box
      sx={{
        backgroundImage: {
          xs: `url(${beforeAfterBgM})`,
          md: `url(${beforeAfterBg})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",

        backgroundRepeat: "no-repeat",

        py: {
          xs: 4,
          md: 6,
        },
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",

            flexWrap: "wrap",

            alignItems: "center",

            justifyContent: "space-between",

            gap: {
              xs: 6,
              lg: 4,
            },
          }}
        >
          {/* LEFT SIDE */}

          <Box
            sx={{
              width: {
                xs: "100%",
                lg: "42%",
              },
            }}
          >
            {/* Badge */}

            <Box
              sx={{
                display: "inline-flex",

                alignItems: "center",

                gap: 1,

                px: 2.5,

                py: 1,

                borderRadius: "999px",

                background: "rgba(255,255,255,.78)",

                backdropFilter: "blur(18px)",

                border: "1px solid rgba(0,87,255,.08)",

                boxShadow: "0 10px 30px rgba(0,87,255,.08)",

                color: "#0057FF",

                fontWeight: 700,

                fontSize: {
                  xs: "8px",
                  md: "10px",
                },

                letterSpacing: "1px",

                textTransform: "uppercase",
              }}
            >
              ✦ Before / After
            </Box>

            {/* Heading */}

            <Typography
              sx={{
                mt: 2,

                fontWeight: 900,

                lineHeight: 1.05,

                letterSpacing: "-1px",

                fontSize: {
                  xs: "38px",
                  sm: "46px",
                  md: "56px",
                  lg: "56px",
                },
              }}
            >
              <Box
                component="span"
                sx={{
                  color: "#07122F",
                  display: "block",
                }}
              >
                See The Difference
              </Box>

              <Box
                component="span"
                sx={{
                  background: "linear-gradient(135deg,#0057ff,#2f8cff)",
                  WebkitBackgroundClip: "text",
                  display: "block",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Before & After
              </Box>
            </Typography>

            {/* Description */}

            <Typography
              sx={{
                mt: 2,

                // maxWidth: "540px",

                color: "#64748b",

                lineHeight: 1.9,

                fontSize: {
                  xs: "14px",
                  md: "16px",
                },
              }}
            >
              Professional garment care that transforms your clothes from worn
              and stained to fresh, clean and perfectly finished.
            </Typography>

            {/* FEATURES */}

            <Box
              sx={{
                mt: 4,

                display: "flex",

                flexDirection: "column",
                gap: 0.5,
              }}
            >
              {features.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",

                    alignItems: "flex-start",

                    gap: {
                      xs: 1.5,
                      md: 2,
                    },

                    py: {
                      xs: 1.5,
                      md: 2,
                    },

                    borderBottom:
                      index !== features.length - 1
                        ? "1px solid #E8EEF9"
                        : "none",
                  }}
                >
                  {/* ICON */}

                  <Box
                    sx={{
                      width: {
                        xs: 38,
                        md: 42,
                      },

                      height: {
                        xs: 38,
                        md: 42,
                      },

                      borderRadius: "50%",

                      background: "#ffffff",

                      border: "1.5px solid #4A8CFF",

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",

                      color: "#2563EB",

                      fontSize: {
                        xs: "14px",
                        md: "16px",
                      },

                      flexShrink: 0,

                      boxShadow: `
      0 4px 15px rgba(37,99,235,.08),
      inset 0 1px 0 rgba(255,255,255,.9)
    `,
                    }}
                  >
                    {item.icon}
                  </Box>

                  {/* CONTENT */}

                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontWeight: 700,

                        color: "#1E293B",

                        lineHeight: 1.2,

                        fontSize: {
                          xs: "15px",
                          md: "18px",
                        },
                      }}
                    >
                      {item.title}
                    </Typography>

                    <Typography
                      sx={{
                        mt: 0.3,

                        color: "#64748B",

                        lineHeight: 1.5,

                        fontWeight: 400,

                        fontSize: {
                          xs: "12px",
                          md: "14px",
                        },
                      }}
                    >
                      {item.desc}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>

            {/* STATS */}

            <Box
              sx={{
                mt: 3,

                display: "flex",

                gap: {
                  xs: 0.8,
                  md: 1.2,
                },

                flexWrap: "wrap",
              }}
            >
              {stats.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    flex: {
                      xs: "1 1 calc(33.33% - 6px)",
                      md: "1",
                    },

                    minWidth: {
                      xs: "95px",
                      md: "120px",
                    },

                    p: {
                      xs: 1,
                      md: 1.4,
                    },

                    borderRadius: "16px",

                    background:
                      "linear-gradient(180deg,rgba(255,255,255,.92),rgba(248,251,255,.85))",

                    border: "1px solid rgba(255,255,255,.9)",

                    backdropFilter: "blur(12px)",

                    boxShadow: "0 8px 20px rgba(0,87,255,.06)",

                    display: "flex",

                    alignItems: "center",

                    gap: {
                      xs: 0.8,
                      md: 1.2,
                    },
                    backgroundImage: `url(${bg_2})`,
                    backgroundSize: "cover",

                    backgroundPosition: "center",

                    backgroundRepeat: "no-repeat",
                  }}
                >
                  {/* Icon */}

                  <Box
                    sx={{
                      width: {
                        xs: 30,
                        md: 38,
                      },

                      height: {
                        xs: 30,
                        md: 38,
                      },

                      borderRadius: "50%",

                      background: "linear-gradient(135deg,#0057FF,#3A8DFF)",

                      color: "#fff",

                      display: "flex",

                      alignItems: "center",

                      justifyContent: "center",

                      fontSize: {
                        xs: "11px",
                        md: "14px",
                      },

                      flexShrink: 0,
                    }}
                  >
                    {item.icon}
                  </Box>

                  {/* Text */}

                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 800,

                        color: "#0057FF",

                        lineHeight: 1,

                        fontSize: {
                          xs: "14px",
                          md: "22px",
                        },
                      }}
                    >
                      {item.number}
                    </Typography>

                    <Typography
                      sx={{
                        color: "#64748B",

                        lineHeight: 1.1,

                        fontWeight: 500,

                        fontSize: {
                          xs: "9px",
                          md: "13px",
                        },
                      }}
                    >
                      {item.label}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>

            {/* BUTTON */}

            {/* <Button
              endIcon={<FaArrowRight />}
              sx={{
                mt: 4,

                px: 4,

                py: 1.8,

                borderRadius: "60px",

                background: "linear-gradient(135deg,#0057FF,#2F8CFF)",

                color: "#fff",

                fontWeight: 700,

                textTransform: "none",

                fontSize: "16px",

                boxShadow: "0 15px 40px rgba(0,87,255,.25)",

                "&:hover": {
                  background: "linear-gradient(135deg,#0057FF,#2F8CFF)",
                },
              }}
            >
              View Full Transformation
            </Button> */}
          </Box>

          {/* RIGHT SIDE */}

          <Box
            sx={{
              width: {
                xs: "100%",
                lg: "52%",
              },
            }}
          >
            <Box
              sx={{
                position: "relative",

                borderRadius: {
                  xs: "30px",
                  md: "40px",
                },

                overflow: "hidden",

                background:
                  "linear-gradient(180deg,rgba(255,255,255,.92),rgba(248,251,255,.82))",

                backdropFilter: "blur(18px)",

                border: "1px solid rgba(255,255,255,.8)",

                boxShadow: "0 25px 80px rgba(0,87,255,.12)",
              }}
            >
              <img
                src={beforeAfterImage}
                alt="Before After"
                style={{
                  width: "100%",
                  display: "block",
                }}
              />

              {/* <Box
                sx={{
                  position: "absolute",

                  top: 25,

                  left: 25,

                  px: 2,

                  py: 1,

                  borderRadius: "12px",

                  background: "#3b475d",

                  color: "#fff",

                  fontWeight: 700,
                }}
              >
                BEFORE
              </Box>

              <Box
                sx={{
                  position: "absolute",

                  top: 25,

                  right: 25,

                  px: 2,

                  py: 1,

                  borderRadius: "12px",

                  background: "#0057FF",

                  color: "#fff",

                  fontWeight: 700,
                }}
              >
                AFTER
              </Box> */}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default BeforeAfterSection;
